import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { StandardDonationsService } from '@rspl-api';
import { EMPTY } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import * as fromActions from './standard-donation.actions';

@Injectable()
export class StandardDonationEffects {
  getStandardDonations = createEffect(() => {
    return this.actions$.pipe(
      ofType(fromActions.getStandardDonations),
      switchMap((params) =>
        this.service.filter(params.findParams).pipe(
          map((response) =>
            fromActions.getStandardDonationsSuccess({
              resultsCount: response.totalResults,
              results: response.results,
            }),
          ),
          catchError(() => EMPTY),
        ),
      ),
    );
  });

  getStandardDonation = createEffect(() => {
    return this.actions$.pipe(
      ofType(fromActions.getStandardDonation),
      switchMap((params) =>
        this.service.find(params.id).pipe(
          map((standardDonation) => fromActions.getStandardDonationSuccess({ standardDonation })),
          catchError(() => EMPTY),
        ),
      ),
    );
  });

  constructor(
    private actions$: Actions,
    private service: StandardDonationsService,
  ) {}
}
